import axios from 'axios';
import { errorHandler } from '@/services/errorHandler';

const synergy4 = window.synergy4;

export default {
    name: 'projects Management',
    state: {
        selectedProject: null
    },
    getters: {
        getSelectedProject: state => state.selectedProject
    },
    mutations: {
        setSelectedProject: (state, project) => {
            state.selectedProject = project;
        }
    },
    actions: {
        fetchNewProjects: async (context) => {
            return await axios.get(`${synergy4}api/devprojects/getallprojects`)
                .then(({data})=>data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        // Project Notes Actions
        fetchProjectNotes: async (context, projectName) => {
            return await axios.get(`${synergy4}api/project-notes/project/${projectName}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
        fetchNoteById: async (context, noteId) => {
            return await axios.get(`${synergy4}api/project-notes/${noteId}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
        createProjectNote: async (context, payload) => {
            return await axios.post(`${synergy4}api/project-notes/add?projectName=${payload.projectName}&noteContent=${payload.noteContent}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
        updateProjectNote: async (context, payload) => {
            return await axios.put(`${synergy4}api/project-notes/${payload.noteId}?noteContent=${payload.noteContent}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },

        // Project URLs Actions
        fetchProjectUrls: async (context, projectName) => {
            return await axios.get(`${synergy4}api/project-urls/project/${projectName}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
        fetchUrlById: async (context, urlId) => {
            return await axios.get(`${synergy4}api/project-urls/${urlId}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
        createProjectUrl: async (context, payload) => {
            return await axios.post(`${synergy4}api/project-urls/add?projectName=${payload.projectName}&urlName=${payload.urlName}&url=${payload.url}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
        updateProjectUrl: async (context, payload) => {
            return await axios.put(`${synergy4}api/project-urls/${payload.urlId}?urlName=${payload.urlName}&url=${payload.url}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
        deleteProjectUrl: async (context, urlId) => {
            return await axios.delete(`${synergy4}api/project-urls/${urlId}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
        fetchSprintsByProject: async (context,payload) => {
            return await axios.get(`${synergy4}sprints/project/${payload}`)
            .then(({data})=>data)
            .catch((err) => {
                errorHandler.tomcatError(err)
                throw err;
            })
        },
        fetchTeamMembersByProject: async (context,payload) => {
            return await axios.get(`${synergy4}api/devprojects/get-team-by-projectName?projectName=${payload}`)
            .then(({data})=>data)
            .catch((err) => {
                errorHandler.tomcatError(err)
                throw err;
            })
        },
        fetchTeamMembersById: async (context,payload) => {
            return await axios.get(`${synergy4}api/devprojects/get-team-members?teamId=${payload}`)
            .then(({data})=>data)
            .catch((err) => {
                errorHandler.tomcatError(err)
                throw err;
            })
        },
        fetchAllTeam: async (context,payload) => {
            return await axios.get(`${synergy4}api/devprojects/getallteams`)
            .then(({data})=>data)
            .catch((err) => {
                errorHandler.tomcatError(err)
                throw err;
            })
        },
        fetchAllDevelopers: async (context,payload) => {
            return await axios.get(`${synergy4}users/developers`)
            .then(({data})=>data)
            .catch((err) => {
                errorHandler.tomcatError(err)
                throw err;
            })
        },
        createProject: async (context,payload) => {
            return await axios.post(`${synergy4}api/devprojects/create-project?projectName=${payload.projectName}&startDate=${payload.startDate}&endDate=${payload.endDate}&type=${payload.type}&status=${payload.status}`)
            .then(({data})=>data)
            .catch((err) => {
                errorHandler.tomcatError(err)
                throw err;
            })
        },
        assignTeam: async (context,payload) => {
            return await axios.post(`${synergy4}api/devprojects/assign-team?projectName=${payload.projectName}&teamId=${payload.teamId}`)
            .then(({data})=>data)
            .catch((err) => {
                errorHandler.tomcatError(err)
                throw err;
            })
        },
        updateProject: async (context,payload) => {
            return await axios.put(`${synergy4}api/devprojects/update-project?project_name=${payload.currentName}&newProjectName=${payload.newName}`)
            .then(({data})=>data)
            .catch((err) => {
                errorHandler.tomcatError(err)
                throw err;
            })
        },
        updateSprint: async (context,payload) => {
            return await axios.put(`${synergy4}sprints/update-title?sprintId=${payload.sprintId}&newTitle=${payload.newTitle}`)
            .then(({data})=>data)
            .catch((err) => {
                errorHandler.tomcatError(err)
                throw err;
            })
        },

        fetchDevTasksByProject: async (context,payload) => {
            return await axios.get(`${synergy4}tasks/project/${payload}`)
                .then(({data})=>data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        // Project Documents Actions
        fetchProjectDocuments: async (context, projectName) => {
            return await axios.get(`${synergy4}api/project-documents/project/${projectName}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
        fetchDocumentById: async (context, documentId) => {
            return await axios.get(`${synergy4}api/project-documents/${documentId}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
        uploadDocument: async (context, payload) => {
            return await axios.post(`${synergy4}api/project-documents/upload`,payload)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
        downloadDocument: async (context, documentId) => {
            return window.location.href = `${synergy4}api/project-documents/download/${documentId}`;
        },
        deleteDocumentpdf: async (context, documentId) => {
            return await axios.delete(`${synergy4}api/project-documents/${documentId}`)
                .then(({data}) => data)
                .catch((err) => {
                    errorHandler.tomcatError(err)
                    throw err;
                })
        },
    }
}
